module.exports = {
    SCHEDULE_GET: 'SCHEDULE_GET',
    SCHEDULE_PROGRAM_ONLINE: 'SCHEDULE_PROGRAM_ONLINE',
    SCHEDULE_CHUNK_RECEIVED: 'SCHEDULE_CHUNK_RECEIVED',
    SCHEDULE_PROGRAM_TYPES_CHANGED: 'SCHEDULE_PROGRAM_TYPES_CHANGED',
};
